import { render, staticRenderFns } from "./ObserveModule.vue?vue&type=template&id=a3d23c24&"
import script from "./ObserveModule.vue?vue&type=script&lang=js&"
export * from "./ObserveModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3d23c24')) {
      api.createRecord('a3d23c24', component.options)
    } else {
      api.reload('a3d23c24', component.options)
    }
    module.hot.accept("./ObserveModule.vue?vue&type=template&id=a3d23c24&", function () {
      api.rerender('a3d23c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/ObserveModule.vue"
export default component.exports